<!-- eslint-disable max-len -->
<template>
  <div>
    <!--Messages d'erreur-->
    <div class="justify-content-center mx-auto col-12 error-messages-container">
      <Alert
        type="warning"
        message="Veuillez vérifier que tous les champs sont correctement remplis"
        :visible="validationError"
        @close="validationError = false" />

      <Alert
        type="danger"
        message="Nous rencontrons des difficultés pour vous connecter. Veuillez réessayer dans quelques instants."
        :visible="authError"
        @close="authError = false" />

      <Alert
        type="danger"
        message="L'identifiant ou le mot de passe est incorrect. Vérifiez vos informations."
        :visible="invalidCredentials"
        @close="invalidCredentials = false" />

      <Alert
        type="danger"
        message="Votre compte n'est pas actif. Contactez le support pour plus d'informations."
        :visible="disabledUser"
        @close="disabledUser = false" />
    </div>
    <!--#Messages d'erreur-->

    <div class="row justify-content-center">
      <form @submit="handleFormSubmit" ref="oauthForm" :action="oauthFormAction" method="POST" class="col-12">
        <fieldset class="login-fields-container">
          <div class="form-group row">
            <label for="idInput" class="col-sm-12 col-md-5 col-form-label">Identifiant</label>
            <div class="col-sm-12 col-md-7">
              <input id="idInput"
                     type="text"
                     class="form-control"
                     name="login"
                     v-model="login"
                     :class="{ 'is-invalid': formSubmitted && !this.$v.login.required }"
                     @input="onLoginInput">
              <div v-if="formSubmitted && !this.$v.login.required" class="mt-1">
                <div class="text-danger small">
                  Champ requis
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label for="passwordInput" class="col-sm-12 col-md-5 col-form-label">
              Mot de passe
            </label>
            <div class="col-sm-12 col-md-7">
              <input id="passwordInput"
                     :type="passwordType"
                     class="form-control"
                     name="password"
                     :class="{ 'is-invalid': formSubmitted && !this.$v.password.required }"
                     @input="onPasswordInput"
                     v-model="password">
              <div v-if="formSubmitted && !this.$v.password.required" class="mt-1">
                <div class="text-danger small">
                  Champ requis
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="form-check my-4 text-center">
          <input type="checkbox" class="form-check-input"
                 @click="switchVisibility" id="switchVisibility">
          <label class="form-check-label text-label" for="switchVisibility">
            Afficher le mot de passe
          </label>
        </div>

        <div class="row justify-content-center my-4">
          <div class="col-12 col-sm-8 mt-3">
            <button type="submit" class="btn btn-block btn-sm text-white fond-indigo" :disabled="isLoading">
              {{ isLoading ? 'Connexion en cours...' : 'Se connecter' }}
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Alert from '../Alert.vue';

export default {
  name: 'OAuthLoginForm',
  props: {
    oauthParams: {
      type: Object,
      required: true,
    },
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      passwordType: 'password',
      validationError: false,
      authError: false,
      invalidCredentials: false,
      disabledUser: false,
      login: '',
      password: '',
      formSubmitted: false,
      isLoading: false,
    };
  },
  computed: {
    oauthFormAction() {
      // Build the form action URL with OAuth query parameters
      const params = new URLSearchParams({
        response_type: this.oauthParams.response_type,
        client_id: this.oauthParams.client_id,
        redirect_uri: this.oauthParams.redirect_uri,
        state: this.oauthParams.state,
      });
      return `/api/front/account/authorize?${params.toString()}`;
    },
  },
  components: {
    Alert,
  },
  mounted() {
    this.validateOAuthParams();
    this.handleErrorParam();
  },
  methods: {
    handleErrorParam() {
      switch (this.error) {
        case 'missing_credentials':
          this.validationError = true;
          break;
        case 'invalid_credentials':
          this.invalidCredentials = true;
          break;
        case 'server_error':
          this.authError = true;
          break;
        default:
          break;
      }
    },
    validateOAuthParams() {
      const p = this.oauthParams;
      // eslint-disable-next-line camelcase
      if (!p.response_type || !p.client_id || !p.redirect_uri || !p.state) {
        // Redirection vers la page d'erreur OAuth
        this.$router.push({ name: 'OAuthUnauthorized' });
      }
    },
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    onLoginInput() {
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.authError = false;
      this.invalidCredentials = false;
      this.disabledUser = false;
    },
    onPasswordInput() {
      if (this.formSubmitted) this.formSubmitted = false;
      this.validationError = false;
      this.authError = false;
      this.invalidCredentials = false;
      this.disabledUser = false;
    },
    handleFormSubmit(e) {
      e.preventDefault();
      this.formSubmitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.validationError = true;
        return;
      }

      this.isLoading = true;
      // Submit the form after a short delay to show the loading state
      setTimeout(() => {
        this.$refs.oauthForm.submit();
      }, 100);
    },
  },
  validations: {
    login: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.login-fields-container {
  margin-left: 8px;
}
</style>
